var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c(this.headerOption.header,{tag:"component"}),_vm._v(" "),_c('div',{staticStyle:{"min-height":"100vh"}},[_c('router-view')],1),_vm._v(" "),(
      _vm.$store.getters.getAuthData.data &&
        _vm.$store.getters.getAuthData.data.mhs_jalur
    )?_c('div',{staticStyle:{"z-index":"10000"}},[_c('my-chat')],1):_vm._e(),_vm._v(" "),_c('my-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c670a288","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 